// extracted by mini-css-extract-plugin
export default {"container":"RM-z","topReviewHeading":"SM-z","criticalReview":"TM-z","favorableReview":"UM-z","vsSeparator":"VM-z"};